import { render, staticRenderFns } from "./AppLayoutFooter.vue?vue&type=template&id=53f5bd3c&scoped=true&"
import script from "./AppLayoutFooter.vue?vue&type=script&lang=js&"
export * from "./AppLayoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutFooter.vue?vue&type=style&index=0&id=53f5bd3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f5bd3c",
  null
  
)

export default component.exports